import React, { useState } from 'react';
import { Copy, Check, Link2 } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import { Input } from '@cotera/client/v0/components/ui/input';
import { Button } from '@cotera/client/v0/components/ui/button';
import { WebhookConfigCard } from './webhook-config-card';

async function copyToClipboard(value: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard !== undefined) {
    await navigator.clipboard.writeText(value);
  }
}

export const WebhookEndpointPanel: React.FC<{
  deliveryUrl?: string;
  secret?: string;
  secretLabel?: string;
  secretDescription?: string;
  singleWebhookEndpoint?: boolean;
}> = ({
  deliveryUrl,
  secret,
  secretLabel = 'Signing secret (shown once)',
  secretDescription,
  singleWebhookEndpoint,
}) => {
  const [copiedField, setCopiedField] = useState<'url' | 'secret' | null>(null);

  const handleCopy = async (
    field: 'url' | 'secret',
    value: string
  ): Promise<void> => {
    await copyToClipboard(value);
    setCopiedField(field);
    window.setTimeout(() => setCopiedField(null), 1500);
  };

  if (deliveryUrl === undefined && secret === undefined) {
    return null;
  }

  return (
    <WebhookConfigCard
      icon={<Link2 />}
      title="Webhook endpoint"
      description={
        singleWebhookEndpoint === true
          ? 'This provider shares one delivery URL across triggers in your org.'
          : undefined
      }
    >
      {deliveryUrl !== undefined ? (
        <div className="space-y-1.5">
          <Text.Caption className="text-muted-foreground block">
            URL
          </Text.Caption>
          <div className="flex gap-2">
            <Input readOnly value={deliveryUrl} className="font-mono text-xs" />
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => void handleCopy('url', deliveryUrl)}
            >
              {copiedField === 'url' ? (
                <Check className="h-4 w-4" />
              ) : (
                <Copy className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>
      ) : null}
      {secret !== undefined && secret !== '' ? (
        <div className="space-y-1.5">
          <Text.Caption className="text-muted-foreground block">
            {secretLabel}
          </Text.Caption>
          {secretDescription !== undefined ? (
            <Text.Caption className="text-muted-foreground block text-xs">
              {secretDescription}
            </Text.Caption>
          ) : null}
          <div className="flex gap-2">
            <Input readOnly value={secret} className="font-mono text-xs" />
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => void handleCopy('secret', secret)}
            >
              {copiedField === 'secret' ? (
                <Check className="h-4 w-4" />
              ) : (
                <Copy className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>
      ) : null}
    </WebhookConfigCard>
  );
};
